import { Injectable } from '@angular/core';
import { AlertApiService } from './alert.api.service';
import { Alert } from '../../models/alert';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class AlertDomainService {

    constructor(private alertApiService: AlertApiService) { }

    getAlertsByUser(): Observable<Alert[] | {}> {
        return this.alertApiService.getAlertsByUser();
    }

    getAlertsByJob(jobId: string): Observable<Alert[] | {}> {
        return this.alertApiService.getAlertsByJob(jobId);
    }

    createAlert(alert: Alert): Observable<any> {
        return this.alertApiService.createAlert(alert);
    }

    deleteAlert(alertId: string): Observable<any> {
        return this.alertApiService.deleteAlert(alertId);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/alert/alert.domain.service.ts